import services from "@/http";
import store from "@/store";
import * as storage from "../storage";

import { setAllConselheiros } from "@/modules/conselheiros/storage.js";
import { setAllPessoas } from "@/modules/pessoas_fisica/storage.js";

import * as types from "./mutation-types";
import MD5 from "crypto-js/md5";
const crypto = require("crypto");
import moment from "moment";
import { clearLocalStorage } from "@/helpers/functions/localStorage";

export const ActionDoLogin = async ({ dispatch }, payload) => {
  try {
    const salt = process.env.VUE_APP_ROOT_API + moment().format("Y-MM-DD");
    payload.salt = MD5(salt).toString();

    const { data } = await services.auth.login(payload);
    dispatch("loadUserLogin", data);
  } catch (error) {
    Promise.reject(error);
  }
};

export const ActionDoLoginToken = async ({ dispatch }, payload) => {
  try {
    const salt = process.env.VUE_APP_ROOT_API + moment().format("Y-MM-DD");
    payload.salt = MD5(salt).toString();

    const { data } = await services.auth.login_sis(payload);
    dispatch("loadUserLogin", data);
  } catch (error) {
    Promise.reject(error);
  }
};

export const loadUserLogin = async ({ dispatch }, data) => {
  const user = data.user;
  if (user.roles && user.roles.length) {
    dispatch("ActionSetUser", user);
    dispatch("ActionSetToken", { token: data.access_token });
    dispatch("ActionSetPermissions", user.permissions);
  }

  dispatch("ActionsLimparSessionStorage");
  clearLocalStorage("@conselhos/conselheiros");
};

export const ActionCheckToken = async ({ state, dispatch }) => {
  const token = storage.getLocalToken();

  if (!token) {
    return Promise.reject(new Error("Token Inválido"));
  }

  if (!state.token) {
    await dispatch("ActionSetToken", { token: token });
  }

  if (!state.user || !state.user.id) {
    await dispatch("ActionLoadSession");
  }
};

export const ActionLoadSession = async ({ dispatch }) => {
  try {
    const { data } = await services.auth.loadSession().then((res) => {
      return res;
    });
    dispatch("ActionSetUser", data.user);
  } catch (err) {
    dispatch("ActionSignOut");
  }
};

export const ActionSetUser = ({ commit }, payload) => {
  commit(types.SET_USER, payload);
};

export const ActionSetPermissions = ({ commit }, payload) => {
  storage.setPermissions(payload);
  commit(types.SET_PERMISSIONS, payload);
};

export const ActionSetToken = ({ commit }, payload) => {
  if (payload.token && payload.expires_in > 0) {
    let date_expire = moment();
    date_expire.add(payload.expires_in, "seconds");
    //storage.setExpiresIn(date_expire.format("YYYY-MM-DD HH:mm"));
  }

  commit(types.SET_TOKEN, payload.token);
  storage.setLocalToken(payload.token);
  storage.setHeaderToken(payload.token);
};

export const ActionSignOut = async ({ dispatch }) => {
  if (store.getters["auth/hasToken"]) {
    try {
      await services.auth.logout();
    } catch (errr) {
      Promise.reject(errr);
    }

    storage.setHeaderToken("");
    storage.deleteLocalToken();
    dispatch("ActionSetUser", {});
    dispatch("ActionSetToken", { token: "" });
    dispatch("ActionSetLogout", true);
  }
};

export const ActionRefresh = async ({ dispatch }) => {
  try {
    const { data } = await services.auth.refresh();
    await dispatch("ActionSetToken", data.access_token);
    dispatch("ActionSetPermissions", data.user.permissions);
  } catch (e) {
    dispatch("ActionSetPermissions", []);
    //console.log("E", e);
  }
};

export const ActionEmailVerify = async ({ dispatch }) => {
  try {
    const { data } = await services.auth.verify();
    await dispatch("ActionSetToken", data.access_token);
  } catch (e) {
    //console.log("E", e);
  }
};

export const ActionForgotPassword = async (store, payload) => {
  try {
    await services.auth.forgotPassword(payload);
  } catch (e) {
    //console.log("E", e);
  }
};

export const ActionResetPassword = async (store, payload) => {
  await services.auth.resetPassword(payload);
};

export const ActionSetLogout = async ({ commit }, payload) => {
  commit(types.SET_LOGOUT, payload);
};

export const ActionsLimparSessionStorage = async (store, payload) => {
  setAllConselheiros(null);
  setAllPessoas(null);
};

export const ActionDecodeToken = async (store, token) => {
  const tokenDecode = await decodeJWT(token);
  return tokenDecode;
};

async function decodeJWT(token) {
  const [header, payload, signature] = token.split(".");

  const decodedHeader = JSON.parse(base64Decode(header));
  const decodedPayload = JSON.parse(base64Decode(payload));

  let secretKey = null;
  switch (decodedPayload.origem) {
    case "gesconselho":
      secretKey = process.env.VUE_APP_GESCONSELHO_SECRET
      break;
    case "gesplanos":
      secretKey = process.env.VUE_APP_GESPLANOS_SECRET;;
      break;
    case "infopolis":
      secretKey = process.env.VUE_APP_INFOPOLIS_SECRET;
      break;
  }

  const isValid = await validateJWT(token, secretKey);

  if (isValid) {
    return {
      payload: decodedPayload,
      signature: signature,
    };
  }
  return null;
}

async function validateJWT(token, secretKey) {
  const [header, payload, signature] = token.split(".");

  const message = `${header}.${payload}`;
  const expectedSignature = await base64Encode(
    await hmacSHA256(secretKey, message)
  );

  return signature === expectedSignature;
}

/*
async function hmacSHA256(key, message) {
  const encoder = new TextEncoder();
  const keyData = encoder.encode(key);
  const messageData = encoder.encode(message);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const signature = await crypto.subtle.sign("HMAC", cryptoKey, messageData);
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
*/

async function hmacSHA256(key, message) {
  return crypto
    .createHmac("sha256", key)
    .update(message)
    .digest("base64")
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
}

function base64Encode(str) {
  return Buffer.from(str).toString("base64");
}

function base64Decode(str) {
  return Buffer.from(str, "base64").toString();
}
